export default function LoadingIcon() {
  return null

  return <div className="mb-4 d-flex gap-2 align-items-center">
    <input className="auth__inputCheck" type="checkbox" name="keep" id="keep" />
    <label className="lh-1 mt-2 ml-2" htmlFor="keep">
      Keep me signed in
    </label>
  </div>
}
